import { PM_PROVIDERS } from 'common/constants/constants';
import { PROGRESSION_TABLE_MODEL } from './model';

const NAME_COLS = {
  KEY: {
    dataPoint: PROGRESSION_TABLE_MODEL.KEY_CELL,
    name: 'KEY'
  },
  TITLE: {
    dataPoint: PROGRESSION_TABLE_MODEL.TITLE_CELL,
    name: 'NAME'
  }
};

export const commonNameColsByProvider = {
  [PM_PROVIDERS.JIRA]: [NAME_COLS.KEY, NAME_COLS.TITLE],
  [PM_PROVIDERS.AZURE_BOARDS]: [NAME_COLS.TITLE]
};
